<template>
    <b-row>
        <b-col cols="2"></b-col>
        <b-col cols="8">
            <div id="wrapper">
                <div id="carousel">
                    <ul>
                        <li>
                            <a href="/slider/img/1.jpg" data-lightbox="roadtrip" title="Laweta">
                                <img src="/slider/img/thumb/thumb_1.jpg" alt="thumb_1.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/2.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_2.jpg" alt="thumb_2.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/3.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_3.jpg" alt="thumb_3.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/4.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_4.jpg" alt="thumb_4.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/5.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_5.jpg" alt="thumb_5.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/6.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_6.jpg" alt="thumb_6.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/7.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_7.jpg" alt="thumb_7.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/8.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_8.jpg" alt="thumb_8.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/9.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_9.jpg" alt="thumb_9.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/10.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_10.jpg" alt="thumb_10.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/11.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_11.jpg" alt="thumb_11.jpg" /></a>
                        </li>
                        <li>
                            <a href="/slider/img/12.jpg" data-lightbox="roadtrip" title="Laweta"><img
                                    src="/slider/img/thumb/thumb_12.jpg" alt="thumb_12.jpg" /></a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <a id="prev" class="prev" href="#">&lt;</a>
                    <a id="next" class="next" href="#">&gt;</a>
                    <div id="pager" class="pager"></div>
                </div>
            </div>
        </b-col>
        <b-col cols="2"></b-col>
    </b-row>
</template>